import { useCallback, useInsertionEffect, useRef } from 'react';

export function useEvent<TCallback extends undefined | ((...args: any[]) => any)>(callback?: TCallback): TCallback {
    const unstableCallbackRef = useRef<TCallback | undefined>(callback);

    useInsertionEffect(() => {
        unstableCallbackRef.current = callback;
    });

    const event = useCallback((...args: Parameters<NonNullable<TCallback>>) => {
        return unstableCallbackRef.current?.(...args);
    }, []) as TCallback;

    return event;
}
